(function () {
  'use strict';
  if (window.__otfCardQuickAddLoaded) return;
  window.__otfCardQuickAddLoaded = true;
  /*
    Secondary Quick add on the shared card body.
    - A genuine single variant (data-otf-quick-add-variant) is added exactly once through the shared
      OTFCartAdd path (the same request ownership, error handling and cart refresh as the quick-buy
      dialog form). Pending, added and failed states are shown on the control; retry is one more tap.
    - OTFCartAdd owns purchase intent per exact variant: while this variant is already being added from
      any entry point (this control, another card showing the same product, the dialog's Add), this
      control sends nothing and simply follows that request's outcome.
    - Every other product keeps its button inside a modal-opener, so quick-add.js opens the same
      Choose options dialog and lands on the first unresolved option. Nothing here chooses a size.
  */
  const BUTTON = '[data-otf-quick-add-variant]';
  const pending = new WeakSet();

  function labelOf(button) {
    return button.querySelector('[data-otf-quick-add-label]');
  }

  function status(button) {
    // The live status region sits outside the fixed-height action row and is associated through aria-describedby.
    const id = button.getAttribute('aria-describedby');
    const described = id && document.getElementById(id);
    if (described && described.matches('[data-otf-quick-add-status]')) return described;
    return button.closest('[data-otf-card]')?.querySelector('[data-otf-quick-add-status]') || button.parentElement?.querySelector('[data-otf-quick-add-status]') || null;
  }

  function setLabel(button, key) {
    const label = labelOf(button);
    const text = button.dataset['otfLabel' + key[0].toUpperCase() + key.slice(1)];
    if (label && text) label.textContent = text;
  }

  function announce(button, message) {
    const element = status(button);
    if (!element) return;
    if (message) {
      element.textContent = message;
      element.hidden = false;
    } else {
      element.textContent = '';
      element.hidden = true;
    }
  }

  function finish(button, state) {
    if (!button.isConnected) return;
    pending.delete(button);
    button.classList.remove('is-pending');
    button.removeAttribute('aria-disabled');
    button.classList.toggle('is-added', state === 'added');
    setLabel(button, state === 'added' ? 'added' : 'idle');
    if (state === 'added') {
      // Confirmed success only: the status region announces it, the control shows it briefly.
      announce(button, button.dataset.otfLabelAdded || '');
      const announced = status(button);
      if (announced) announced.classList.add('is-success');
      clearTimeout(button._otfAddedTimer);
      button._otfAddedTimer = setTimeout(() => {
        if (!button.isConnected) return;
        button.classList.remove('is-added');
        setLabel(button, 'idle');
        if (announced) { announced.classList.remove('is-success'); }
        if (status(button)?.textContent === (button.dataset.otfLabelAdded || '')) announce(button, '');
      }, 2400);
    } else {
      status(button)?.classList.remove('is-success');
    }
  }

  function add(button) {
    if (pending.has(button) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (typeof window.OTFCartAdd?.submit !== 'function' || typeof window.fetchConfig !== 'function' || !window.routes?.cart_add_url) {
      // The shared add path is not available on this page: fall back to the product page.
      const link = button.closest('[data-otf-card]')?.querySelector('.otf-card__title-link, .otf-card__media-link');
      if (link?.href) window.location.assign(link.href);
      return;
    }
    const variantId = button.dataset.otfQuickAddVariant;
    const quantity = Math.max(1, parseInt(button.dataset.otfQuickAddQuantity, 10) || 1);
    if (!/^\d+$/.test(variantId || '')) return;
    pending.add(button);
    button.classList.add('is-pending');
    button.classList.remove('is-added');
    announce(button, '');
    setLabel(button, 'pending');
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', String(quantity));
    let rejected = false;
    let duplicate = false;
    window.OTFCartAdd.submit({
      body,
      submitButton: button,
      source: 'otf-card-quick-add',
      handleErrorMessage: (message) => { if (message) announce(button, message); },
      onRejected: (message) => {
        rejected = true;
        announce(button, message || button.dataset.otfLabelError || window.cartStrings?.error || '');
      },
      onDuplicate: () => {
        // The same variant is already in flight from another entry point: follow it, send nothing.
        duplicate = true;
        button.setAttribute('aria-disabled', 'true');
      },
      onAdded: () => {
        if (button.isConnected) announce(button, '');
        status(button)?.classList.remove('is-success');
      }
    }).then((added) => {
      if (duplicate && !added) announce(button, button.dataset.otfLabelError || window.cartStrings?.error || '');
      finish(button, added && !rejected ? 'added' : 'idle');
    }, () => {
      announce(button, button.dataset.otfLabelError || window.cartStrings?.error || '');
      finish(button, 'idle');
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(BUTTON);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    add(button);
  });

}());
